<div class="sidebar-container">
    <!-- Profile Section -->
    <div class="profile-section" *ngIf="authService.merchants.length > 0 && authService.activeMerchant">
        <div class="profile-info-compact">
            <span class="profile-name">{{ this.merchant?.companyName || 'Loading...' }}</span>
            <span *ngIf="merchant" class="profile-badge" [ngClass]="getPortfolioTypeClass(merchant)">
                {{ getPortfolioType(merchant) }}
            </span>
        </div>
    </div>

    <!-- Navigation Menu -->
    <nav *ngIf="merchant" class="sidebar-nav">
        <ul class="nav-list">
            <li class="nav-item">
                <a [routerLink]="'/merchant/' + merchantKey"
                   class="nav-link"
                   routerLinkActive="nav-link--active"
                   [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon fa-solid fa-gauge-high"></i>
                    <span class="nav-text">Dashboard</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="authService.isAdmin">
                <a [routerLink]="'/merchant/' + merchantKey + '/analytics'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-chart-line"></i>
                    <span class="nav-text">Listing Performance</span>
                </a>
            </li>

            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/insights'" class="nav-link" routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-chart-column"></i>
                    <span class="nav-text">Landlord Insights</span>
                </a>
            </li>

            <!-- ParkUpp (Monthly Parking) items -->
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/bays'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-square-parking"></i>
                    <span class="nav-text">Parking Bay Setup</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/active'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-car"></i>
                    <span class="nav-text">Active Tenants</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/expired'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-circle-xmark"></i>
                    <span class="nav-text">Expired Tenants</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/invoices'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-coins"></i>
                    <span class="nav-text">Payout History</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/proforma-invoices'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-file-invoice"></i>
                    <span class="nav-text">Proforma Invoices</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="!merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/statements'"
                   class="nav-link"
                   routerLinkActive="nav-link--active"
                   target="_blank">
                    <i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
                    <span class="nav-text">Monthly Statements</span>
                    <span class="nav-badge">New</span>
                </a>
            </li>

            <!-- Allocate items -->
            <li class="nav-item" *ngIf="merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/bookupp-parkings'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-square-parking"></i>
                    <span class="nav-text">Parking Bay Setup</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/bookupp-users'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-user-group"></i>
                    <span class="nav-text">Add Users / Parkers</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="merchant?.bookuppEnabled">
                <a [routerLink]="'/merchant/' + merchantKey + '/bookupp-bookings'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-calendar-days"></i>
                    <span class="nav-text">Bookings</span>
                </a>
            </li>

            <li class="nav-divider"></li>

            <li class="nav-item">
                <a [routerLink]="'/merchant/' + merchantKey + '/profile'"
                   class="nav-link"
                   routerLinkActive="nav-link--active">
                    <i class="nav-icon fa-solid fa-gear"></i>
                    <span class="nav-text">Settings</span>
                </a>
            </li>

            <li class="nav-item">
                <a [routerLink]="'/merchant/portfolios'"
                   class="nav-link nav-link--external">
                    <i class="nav-icon fa-solid fa-building"></i>
                    <span class="nav-text">Portfolio Consolidation</span>
                    <i class="nav-external fa-solid fa-arrow-right"></i>
                </a>
            </li>
        </ul>
    </nav>
</div>
